import SimpleAutocompleteFactory from "components/Autocomplete/SimpleAutocompleteFactory"

export type TransactionFilterHasInvoiceValueEnum = "yes" | "no"

export const HasInvoiceFilter = SimpleAutocompleteFactory<TransactionFilterHasInvoiceValueEnum>({
  yes: "Yes",
  no: "No",
})
